export default {
    text_1: "PREMIUM",
    text_2: "ADMIN",
    text_3: "NASTAVENÍ",
    text_4: "Nová cenová nabídka",
    text_5: "Nápady na zlepšení?",
    text_6: "Verze ",
    text_7: "Firma: ",

    nastenka: "Nástěnka",
    cenovePonuky: "Cenové nabídky",
    mojiKlienti: "Moji klienti",
    balicky: "Balíčky",
    novaCenovaPonuka: "Nová cenová nabídka",
    nastaveniaUctu: "Nastavení účtu",
    firmaAKontakty: "Firma a kontakty",
    notifikacie: "Notifikace",
    integracie: "Integrace",
    vlastneFarbyPonuky: "Vlastní barvy nabídky",
    recenzie: "Recenze",
    mojiPouzivatelia: "Moji uživatelé",
    mojeFirmy: "Moje firmy",
    polozkyACeny: "Položky a ceny",
    statistiky: "Statistiky",
    blog: "Blog",
    pouzivatelia: "Uživatelé",
    firmy: "Firmy",
    historiaBalickov: "Historie balíčků",
    impersonating: "Klientské přihlášení",
    subscriptions: "Předplatné",
    alerts: "Upozornění",
    faktury: "Faktury",
    vytvorenychPonuk: "Vytvořených nabídek",
    vytvorenychKlientov: "Vytvořených klientů",
}
